import { z } from "zod";

export const buildReportTemplateSchema = (t: (key: string, opts?: Record<string, string>) => string) =>
  z.object({
    name: z
      .string()
      .trim()
      .min(1, { message: t("validation.nameRequired") }),
    description: z
      .string()
      .trim()
      .min(1, { message: t("validation.descriptionRequired") }),
    content: z
      .string()
      .trim()
      .min(1, { message: t("validation.contentRequired") }),
  });
